import { inject, Injectable } from '@angular/core';
import { ConfigOption, FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyFieldConfigPresetProvider } from '@ngx-formly/core/lib/models';
import { DataSetupFacade } from '@portal/application/data-access';
import { map } from 'rxjs';
import { mapDataSetupSelectOptionToFormly } from '../util';

@Injectable()
export class PropertyTypePresetProvider implements FormlyFieldConfigPresetProvider {
  private readonly dataSetupFacade = inject(DataSetupFacade);

  getConfiguration(): FormlyFieldConfig {
    return {
      type: 'mat-select',
      props: {
        label: 'Property Type',
        placeholder: 'Please Select',
        options: this.dataSetupFacade.dataSetup$?.pipe(
          map(dataSetup => mapDataSetupSelectOptionToFormly(dataSetup?.collateralPropertyTypes)),
        ),
      },
    };
  }
}

export function registerPropertyTypePreset(): ConfigOption {
  return { presets: [{ name: 'propertyType', config: new PropertyTypePresetProvider() }] };
}
